module.exports = __webpack_public_path__ + "static/img/7659790acff7406fde1ff0723844760.be6b8f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7659790acff7406fde1ff0723844760.jpg
// module id = IOHq
// module chunks = 1